"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Divider = _interopRequireDefault(require("../Divider/Divider"));

var _excluded = ["classes", "className", "header", "body", "align", "footer"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {
      outline: "1px solid ".concat(theme.palette.grey.light)
    },
    header: {
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.xl, "px")
    },
    body: {
      padding: "32px ".concat(theme.spacing.xl, "px 40px")
    },
    footer: {
      padding: "32px ".concat(theme.spacing.xl, "px 40px")
    },
    left: {
      textAlign: 'left'
    },
    center: {
      textAlign: 'center'
    },
    right: {
      textAlign: 'right'
    },
    justified: {
      textAlign: 'justified'
    },
    divider: {
      margin: '32px 0px'
    }
  };
};

var Box = function Box(props) {
  var classes = props.classes,
      className = props.className,
      header = props.header,
      body = props.body,
      align = props.align,
      footer = props.footer,
      rest = _objectWithoutProperties(props, _excluded);

  var headerView = header ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, header) : null;

  function formatBody(c) {
    var formattedBody = null;

    if (Array.isArray(c)) {
      formattedBody = c.map(function (node, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: i
        }, node, i !== c.length - 1 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
          className: classes.divider
        }));
      });
    } else {
      formattedBody = c;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.body
    }, formattedBody);
  }

  var bodyView = body ? formatBody(body) : null;
  var footerView = footer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.footer
  }, footer) : null;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx2["default"])(classes.root, _defineProperty({}, classes[align], true), className)
  }, rest), headerView, headerView && bodyView && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), bodyView, footerView);
};

Box.defaultProps = {
  classes: {}
};
Box.propTypes = {
  classes: _propTypes["default"].any,
  className: _propTypes["default"].string,
  header: _propTypes["default"].any,
  body: _propTypes["default"].any,
  footer: _propTypes["default"].any,
  align: _propTypes["default"].oneOf(['left', 'center', 'right', 'justified'])
};

var _default = (0, _reactJss["default"])(styles)(Box);

exports["default"] = _default;